import { networkConfig, getUrlBase, fetchExecutor } from "network/network-util";

export async function fetchAllContractorsApi() {
  const url = getUrlBase() + networkConfig.data.contractors.root;
  return fetchExecutor(
    url,
    {
      method: "GET",
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
    }
  );
}

export async function fetchGetByRangeContractorsApi( position) {
  const url = getUrlBase() + networkConfig.data.contractors.getByRange + "?position=" + position;
  return fetchExecutor(
    url,
    {
      method: "GET",
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      }
    }
  );
}

export async function fetchAppendContractorsApi(payload) {
  const url = getUrlBase() + networkConfig.data.contractors.root;
  const body = JSON.stringify({data: payload});
  return fetchExecutor(
    url,
    {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: body
    }
  );
}

export async function fetchUpdateContractorsApi(payload) {
  const url = getUrlBase() + networkConfig.data.contractors.root;
  const body = JSON.stringify({data: payload});
  return fetchExecutor(
    url,
    {
      method: "POST",
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: body
    }
  );
}
